import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/DemographicsSagas";

export const UpdateButtons = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.demographics.filtersDirty);

  return filtersDirty ? (
    <div id="sticky-btn">
      <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
        Update
      </button>

      <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
        Reset
      </button>
    </div>
  ) : (
    ""
  );
};
